module.exports = __webpack_public_path__ + "img/top.cb3537ad.png";